export const CHAR_LIMIT = 5000

export function textLength(html: string | undefined): number {
  if (!html) {
    return 0
  }
  const doc = new DOMParser().parseFromString(html, 'text/html')
  return (doc.body.textContent ?? '').replace(/\u00a0/g, ' ').trim().length
}

export function hasContent(value: string | undefined): boolean {
  return textLength(value) > 0
}
